import React from 'react';
import { Redirect } from 'react-router-dom';

const AccountsNew = () => {
  return <Redirect to="/start" />
}

export default React.memo(AccountsNew);